import React, { lazy } from 'react'

const TermsOfUsePaymentPage = lazy(() => import('./TermsOfUsePaymentPage'))

export { TermsOfUsePaymentPage }
